import React from 'react';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from '@material-ui/core';
import { Add, ArrowBack, Edit } from '@material-ui/icons';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { SectionLabel } from '../blocks';

// The way back to the profiles grid, a dropdown to switch to another of the org's profiles, Edit, and
// Create. `name` covers the dropdown until the profile list loads.
const HeaderBar = ({
    deliveryProfileId,
    deliveryProfiles = [],
    name,
    onSelect,
    onBack,
    onEdit,
    editDisabled,
    onCreate,
}) => {
    return (
        <Grid
            container
            direction="column"
            css={css`
                padding: 12px 20px;
                gap: 4px;
                flex-wrap: nowrap;
            `}
        >
            <Grid item>
                <Button
                    size="small"
                    onClick={onBack}
                    startIcon={<ArrowBack fontSize="small" />}
                    css={css`
                        padding: 2px 4px;
                        margin-left: -4px;
                        color: ${colors.greys[2]};
                        text-transform: none;
                    `}
                >
                    All profiles
                </Button>
            </Grid>
            <SectionLabel as="label" htmlFor="delivery-profile-select">
                Profile
            </SectionLabel>
            <Grid
                container
                css={css`
                    gap: 10px;
                    flex-wrap: nowrap;
                    align-items: center;
                `}
            >
                <Grid
                    item
                    css={css`
                        flex-grow: 1;
                        min-width: 0;
                    `}
                >
                    <TextField
                        select
                        fullWidth
                        size="small"
                        variant="outlined"
                        id="delivery-profile-select"
                        // Empty until the list has this profile, or MUI warns about an out-of-range value.
                        value={
                            deliveryProfiles.some((option) => option.delivery_profile_id === deliveryProfileId)
                                ? deliveryProfileId
                                : ''
                        }
                        onChange={(e) => onSelect(e.target.value)}
                        SelectProps={{
                            displayEmpty: true,
                            renderValue: (id) =>
                                deliveryProfiles.find((option) => option.delivery_profile_id === id)?.name ||
                                name || (
                                    <span
                                        css={css`
                                            color: ${colors.greys.primary};
                                        `}
                                    >
                                        Loading…
                                    </span>
                                ),
                        }}
                    >
                        {deliveryProfiles.map((option) => (
                            <MenuItem key={option.delivery_profile_id} value={option.delivery_profile_id}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item>
                    {/* Disabled until the profile loads, or editing would save a duplicate. */}
                    <IconButton
                        aria-label="edit delivery profile"
                        onClick={onEdit}
                        disabled={editDisabled}
                        css={css`
                            width: 40px;
                            height: 40px;
                            border: 1px solid ${colors.greys.border};
                            border-radius: 5px;
                        `}
                    >
                        <Edit fontSize="small" />
                    </IconButton>
                </Grid>
                <Grid item>
                    <Tooltip title="Create delivery profile">
                        <IconButton
                            aria-label="create delivery profile"
                            onClick={onCreate}
                            css={css`
                                width: 40px;
                                height: 40px;
                                border: 1px solid ${colors.greens.primary};
                                border-radius: 5px;
                                background: ${colors.greens.primary};
                                color: ${colors.white.primary};

                                &:hover {
                                    background: ${colors.greens.primary};
                                    opacity: 0.85;
                                }
                            `}
                        >
                            <Add fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default HeaderBar;
